export var DropDownOrientation;
(function (DropDownOrientation) {
    DropDownOrientation["TOP"] = "TOP";
    DropDownOrientation["BOTTOM"] = "BOTTOM";
})(DropDownOrientation || (DropDownOrientation = {}));
